/**
 * Manages the states of a button.
 *
 * @param {boolean} showSecondary - Whether a secondary button should be shown.
 **/
export default function swapButton( showSecondary ) {
  const shareButton = document.querySelector( '.js-share-button' )
  const primaryIcon = document.querySelector( '.js-primary-icon' )
  const primaryTitle = document.querySelector( '.js-primary-title' )
  const secondaryIcon = document.querySelector( '.js-secondary-icon' )
  const secondaryTitle = document.querySelector( '.js-secondary-title' )

  if ( !primaryIcon | !primaryTitle | !secondaryIcon | !secondaryTitle ) {
    return
  }

  if ( showSecondary ) {

    shareButton.classList.add( 'bg-blue-100' )
    shareButton.classList.remove( 'bg-blue-80' )

    primaryTitle.classList.add( 'opacity-0', 'hidden' )
    secondaryTitle.classList.remove( 'opacity-0', 'hidden' )

    primaryIcon.classList.remove( 'opacity-50' )
    primaryIcon.classList.add( 'opacity-0', 'hidden' )

    secondaryIcon.classList.remove( 'hidden' )
    secondaryIcon.classList.add( 'opacity-50' )

  } else {

    shareButton.classList.remove( 'bg-blue-100' )
    shareButton.classList.add( 'bg-blue-80' )

    primaryTitle.classList.remove( 'opacity-0', 'hidden' )
    secondaryTitle.classList.add( 'opacity-0', 'hidden' )

    primaryIcon.classList.add( 'opacity-50' )
    primaryIcon.classList.remove( 'opacity-0', 'hidden' )

    secondaryIcon.classList.add( 'hidden' )
    secondaryIcon.classList.remove( 'opacity-50' )

  }
}